export default __webpack_public_path__ + "static/media/small-logo-api.37656696.svg";